import { createContext } from "react";

export const PUBLIC_PRESENTATION_THEME_KEY = "riestro-public-presentation-theme";

export const PublicPresentationThemeContext = createContext(null);

export function readPublicPresentationTheme() {
  try {
    const stored = window.localStorage.getItem(PUBLIC_PRESENTATION_THEME_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch (_err) {
    /* localStorage unavailable */
  }
  return "light";
}

export function writePublicPresentationTheme(theme) {
  if (theme !== "light" && theme !== "dark") return;
  try {
    window.localStorage.setItem(PUBLIC_PRESENTATION_THEME_KEY, theme);
  } catch (_err) {
    /* localStorage unavailable */
  }
}

export function togglePublicPresentationTheme(current) {
  return current === "dark" ? "light" : "dark";
}
